const getters = {
    getMode(state) {
        return state.mode
    }
}

export default getters
